import {BaseMarketingEventHandler} from '../BaseMarketingEventHandler.js';

export class PageViewHandler extends BaseMarketingEventHandler {
    // Реализация регистрации события
    register(event, eventCallback) {
         // Обработчик вызова
        const onPageLoadHandler = () => {
            // Выполнение маркетингового кода
            eventCallback().catch(error => {
                console.error('Ошибка выполнения маркетингового события:', error);
            });
        };

        // Добавляем обработчик, который вызовется один раз при загрузке
        if (document.readyState === 'loading') {
            // Страница еще загружается — подписываемся на событие
            window.addEventListener('DOMContentLoaded', onPageLoadHandler, { once: true });
        } else {
            // Страница уже загружена — вызываем сразу
            onPageLoadHandler();
        }
    }

    execute(event, jsCode) {
        alert('execute');
        try {
            eval(jsCode);
        } catch (error) {
            console.error('Ошибка выполнения jsCode:', error);
        }
    }
}